/**
 * Shape del formulario de filtros de Sitios.
 * Nota: aunque algunos filtros sean "texto", otros usan componentes select que manejan
 * objetos tipo { valor, etiqueta } (no solo strings).
 */
export type TSelectOption = {
  valor: string
  etiqueta: string
}

export type TFormInputs = {
  nombre: string | null
  razonSocial: string | null
  rfc: string | null
  estado: TSelectOption | null
}

/**
 * Declarativo: define campos disponibles para el componente generico de filtros.
 * Se consume para renderizar controles y labels sin duplicar configuracion.
 */
export const filtrosBusqueda = {
  nombre: { etiqueta: 'Nombre', tipo: 'text' },
  razonSocial: { etiqueta: 'Razón social', tipo: 'text' },
  rfc: { etiqueta: 'RFC', tipo: 'text' },
  estado: { etiqueta: 'Estado', tipo: 'select' },
}
